import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	VALIDATE: {
		path: 'validate',
		method: 'POST'
	}
};

export interface IValidateOptions extends IBaseFetchOptions {
	body : {
		shippingContact: {
			countryCode: string;
			administrativeArea: string;
			locality: string;
			postalCode: string;
			addressLines: Array<string>;
			givenName: string;
			familyName: string;
		},
		billingContact: {
			countryCode: string;
			administrativeArea: string;
			locality: string;
			postalCode: string;
			addressLines: Array<string>;
			givenName: string;
			familyName: string;
		}
	};
}

export interface IValidateResponse extends IBaseResponse {
	shippingContact: {
		valid: boolean,
		fields: Record<string, any>;
		custom?: {
			errorMessage?: string;
		};
	},
	billingContact: {
		valid: boolean,
		fields: Record<string, any>;
		custom?: {
			errorMessage?: string;
		};
	}
}
